import React from 'react'
import videoBg from '../assets/DronePortfolio.mp4'
import '../css/Hero.css'

const Hero = () => {
    return (
        <div className='hero' >
            <video className='bg-video' src={videoBg} autoPlay loop muted />
            <div className='overlay'>
                <div className='banner-text'>
                    <h1>
                        Aerial Photo and Video Solutions
                    </h1>
                    {/* <button href='/' className='button'>
                        Contact
                    </button> */}
                </div>
            </div>

        </div>
    );
}

export default Hero